<div class="flex flex-col min-h-screen">
  <app-navbar class="flex-shrink-0"></app-navbar>
  <div class="flex-grow">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="flex-shrink-0"></app-footer>
</div>
